/**
 * Learn more about light and dark modes:
 * https://docs.expo.dev/guides/color-schemes/
 */

import { Colors } from "@/constants/ThemeColours";
import { useColorScheme } from "@/hooks/useColorScheme";

export function useThemeColor(props?: { light?: string; dark?: string }, colorName: keyof typeof Colors.light & keyof typeof Colors.dark = "text") {
  const rawTheme = useColorScheme();
  const theme: "light" | "dark" = rawTheme === "dark" ? "dark" : "light";
  const colorFromProps = props?.[theme];

  if (colorFromProps) {
    return colorFromProps;
  } else {
    const palette = Colors[theme] ?? Colors.light;
    return palette[colorName] ?? Colors.light[colorName];
  }
}
